<template>
    <div class="content">
        <router-view></router-view>
        <div class="content-body">
            <div class="widgets">
              <div class="widgets-wrapper">


                <StatsResumeWidget
                        :title="'Résumé des paiements'"
                        period="current_month"
                        v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsResumeWidget>

                <StatsWidget
                    :title="'Chiffre d\'affaire'"
                    period="current_month"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsWidget>

                <StatsCompareWidget
                    :title="'Evolution du Chiffre d\'affaire'"
                    type="all"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsCompareWidget>

                <StatsAquisitionWidget
                    :title="'Chiffre d\'affaire / aquisition'"
                    type="all"
                    period="current_year"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsAquisitionWidget>

                <StatsAquisitionCohortWidget
                    :title="'Lifetime Value / Clients'"
                    type="all"
                    period="current_year"
                    class-name="full"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsAquisitionCohortWidget>

                <StatsBestCustomers
                    :title="'Classement des 15 clients (meilleur chiffre d\'affaire)'"
                    period="current_month"
                    class-name="full"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsBestCustomers>

                <!--
                <OrderByUserWidget
                    :title="'Vente par employés - ' + branch.name"
                    period="current_month"
                    :branch="branch.id"
                    v-for="branch in $store.state.scope.branches" :class-name="{'full':$store.state.scope.branches.length <= 1}"></OrderByUserWidget>


                <OrderBranchStatsWidget title="Rapport facturation" period="current_year" :branch="null" class-name="full" v-if="$store.state.scope.branches.length > 1"></OrderBranchStatsWidget>
                -->
                <SchedulesDonePerUserWidget
                        title="Rapport facturation"
                        period="current_month"
                        :branch="null"
                        class-name="full"
                        v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></SchedulesDonePerUserWidget>
              </div>
            </div>
        </div>
    </div>
</template>
<script>

    import StatsWidget from './invoice/StatsWidget.vue'
    import StatsAquisitionWidget from './invoice/StatsAquisitionWidget.vue'
    import StatsAquisitionCohortWidget from './invoice/StatsAquisitionCohortWidget.vue'
    import StatsCompareWidget from './invoice/StatsCompareWidget.vue'
    import StatsBestCustomers from './invoice/StatsBestCustomers.vue'
    import StatsResumeWidget from './invoice/StatsResumeWidget.vue'
    import OrderByUserWidget from './invoice/OrderByUserWidget.vue'
    import OrderBranchStatsWidget from './invoice/OrderBranchStatsWidget.vue'
    import SchedulesDonePerUserWidget from '../reservation/SchedulesDonePerUserWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
            }
        },
        components: {
            'StatsWidget' : StatsWidget,
            'StatsAquisitionWidget' : StatsAquisitionWidget,
            'StatsAquisitionCohortWidget' : StatsAquisitionCohortWidget,
            'StatsCompareWidget' : StatsCompareWidget,
            'StatsBestCustomers' : StatsBestCustomers,
            'StatsResumeWidget' : StatsResumeWidget,
            'OrderByUserWidget' : OrderByUserWidget,
            'SchedulesDonePerUserWidget' : SchedulesDonePerUserWidget,
            'OrderBranchStatsWidget' : OrderBranchStatsWidget
        },
        mounted: function(){

        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/Dashboard.vue